var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MapContext } from '../../MapContext';
/**
 * @hidden
 */
var CollectionConfigurationComponent = /** @class */ (function (_super) {
    __extends(CollectionConfigurationComponent, _super);
    function CollectionConfigurationComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.optionsStore = context.optionsStore;
        return _this;
    }
    CollectionConfigurationComponent.prototype.renderChildren = function (child, index) {
        var children = child.props.children;
        var _a = this.props, _mapKey = _a._mapKey, _parentStore = _a._parentStore;
        var collectionItemProps = __assign(__assign({}, child.props), { _mapCollectionIdxKey: "".concat(_mapKey, "_").concat(index), _parentStore: _parentStore });
        return React.cloneElement(child, collectionItemProps, children);
    };
    CollectionConfigurationComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, _mapKey = _a._mapKey, _parentStore = _a._parentStore, children = _a.children;
        var store = _parentStore || this.optionsStore;
        store.dispatch({
            mapKey: _mapKey,
            payload: []
        });
        return React.Children.map(children, function (child, index) {
            if (React.isValidElement(child)) {
                return _this.renderChildren(child, index);
            }
            return child;
        });
    };
    CollectionConfigurationComponent.contextType = MapContext;
    return CollectionConfigurationComponent;
}(React.Component));
export default CollectionConfigurationComponent;
